import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { FilterEntry, FilterType } from "hooks/filters";
import { type Dispatch, useMemo } from "react";

export interface GradeFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  brands?: Array<AutocompleteData>;
  gradeProperties?: Array<AutocompleteData>;
  gradeNumbers?: Array<AutocompleteData>;
  industry?: Array<AutocompleteData>;
  applicationClass?: Array<AutocompleteData>;
  application?: Array<AutocompleteData>;
  t: (key: string) => string;
}

export const GradeFilter = ({
  value = [],
  onChange,
  brands,
  gradeProperties,
  gradeNumbers,
  industry,
  applicationClass,
  application,
  t,
}: GradeFilterProps) => {
  const filters: Array<FilterEntry> = useMemo(
    () =>
      [
        {
          type: "brand" as FilterType,
          value: brands,
        },
        {
          type: "gradeProperty" as FilterType,
          value: gradeProperties,
        },
        {
          type: "gradeNumber" as FilterType,
          value: gradeNumbers,
        },
        {
          type: "industry" as FilterType,
          value: industry,
        },
        {
          type: "applicationClass" as FilterType,
          value: applicationClass,
        },
        {
          type: "application" as FilterType,
          value: application,
        },
      ].filter((e) => e.value !== undefined && e.value.length > 0),
    [
      brands,
      gradeProperties,
      gradeNumbers,
      industry,
      applicationClass,
      application,
    ],
  );

  return (
    <ColorSearchAutocomplete
      label={t("filter_grade")}
      example={t("filter_grade_example")}
      type="grade"
      value={value}
      filters={filters}
      onChange={onChange}
    />
  );
};
